export const TOUCH = "TOUCH";
export const REGISTER_REQUEST = "REGISTER_REQUEST";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const REQUEST_RESET_PASSWORD = "REQUEST_RESET_PASSWORD";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";

export const MY_RIGHTS = "MY_RIGHTS";
export const MY_DATA = "MY_DATA";
export const USER_DATA = "USER_DATA";
export const UPDATE_USER_DATA = "UPDATE_USER_DATA";
export const SIGN_USER_CONTRACT = "SIGN_USER_CONTRACT";
export const USER_SEARCH = "USER_SEARCH";
export const USER_CONTRACT = "USER_CONTRACT";
export const CURRENT_USER_CONTRACT = "CURRENT_USER_CONTRACT";

export const DEBTOR_SEARCH = "DEBTOR_SEARCH";
export const DEBTOR_GET = "DEBTOR_GET";
export const DEBTOR_CREATE = "DEBTOR_CREATE";
export const DEBTOR_UPDATE = "DEBTOR_UPDATE";

export const DELETE_INTERNAL_USER = "DELETE_INTERNAL_USER";
export const CREATE_INTERNAL_USER = "CREATE_INTERNAL_USER";
export const INTERNAL_USER_VALIDATION = "INTERNAL_USER_VALIDATION";
export const IMPERSONATE_USER = "IMPERSONATE_USER";

export const PAYMENT_PLAN_SEARCH = "PAYMENT_PLAN_SEARCH";
export const PAYMENT_PLAN_DETAILS = "PAYMENT_PLAN_DETAILS";
export const CREATE_PAYMENT_PLAN = "CREATE_PAYMENT_PLAN";
export const PAYMENT_PLAN_CONTRACT = "PAYMENT_PLAN_CONTRACT";
export const SIGN_PAYMENT_PLAN_CONTRACT = "SIGN_PAYMENT_PLAN_CONTRACT";
export const PAYMENT_PLAN_SEND_TO_DEBTOR = "PAYMENT_PLAN_SEND_TO_DEBTOR";
export const PAYMENT_PLAN_SECURED_NEXT_SESSION = "PAYMENT_PLAN_SECURED_NEXT_SESSION";

export const GET_PAYMENT_PROVIDER_REQUEST = "GET_PAYMENT_PROVIDER_REQUEST";

export const PAYMENT_PLAN_DETAILS_PUBLIC = "PAYMENT_PLAN_DETAILS_PUBLIC";
export const PAYMENT_PLAN_CONTRACT_PUBLIC = "PAYMENT_PLAN_CONTRACT_PUBLIC";
export const SIGN_PAYMENT_PLAN_CONTRACT_PUBLIC =
  "SIGN_PAYMENT_PLAN_CONTRACT_PUBLIC";
export const GET_PAYMENT_PROVIDER_REQUEST_PUBLIC =
  "GET_PAYMENT_PROVIDER_REQUEST_PUBLIC";


export const PAYMENT_SEARCH = "PAYMENT_SEARCH";
export const PAYMENT_DETAILS = "PAYMENT_DETAILS";
export const PAYMENT_FILE = "PAYMENT_FILE";
export const PAYMENT_MARK_AS_PAYED = "PAYMENT_MARK_AS_PAYED";

export const CREDITOR_PAYMENT_SEARCH = "CREDITOR_PAYMENT_SEARCH";
export const CREDITOR_PAYMENT_DETAILS = "CREDITOR_PAYMENT_DETAILS";
